import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const PasswordInput = forwardRef(({ className, toggleClassName, ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  const baseId = props["data-testid"] || props.id || props.name || "password";

  return (
    <div className="relative">
      <Input ref={ref} {...props} type={visible ? "text" : "password"} className={cn("pr-11", className)} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        data-testid={`${baseId}-toggle-visibility`}
        className={cn(
          "absolute inset-y-0 right-0 flex w-11 items-center justify-center text-slate-400 transition-colors duration-150 hover:text-slate-200 focus-visible:outline-none focus-visible:text-cyan-400",
          toggleClassName
        )}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";
